// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skin-preview {
  height: 5rem;
}`, "",{"version":3,"sources":["webpack://./src/Components/Pages/Admin/AdminSkins/AdminSkins.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF","sourcesContent":[".skin-preview {\n  height: 5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
